Array.from(document.querySelectorAll(".shopify-section--flagtabs-tab")).forEach((container) => {
    let flags = document.querySelectorAll(".shopify-section--flagtabs-flag");
    Array.from(container.querySelectorAll(".flagtabs-tab_btn")).forEach((tag) => {
      tag.addEventListener("click", (event) => {
          var index = parseInt(tag.getAttribute("data-val"));          
          if(flags != null && flags.length > index){
            flags[index].scrollIntoView();
          }
      });
  });
});
